import React, { PropTypes } from 'react';

import { NitroIcon } from 'nitro-components';
import styled from 'styled-components';

const Action = styled.span`
  font-size: 12px;
  color: ${props => props.theme.color.secondary};
`;

const GriddleActions = ({ content, others }) => (
  <Action {...others}>{content} </Action>
);

GriddleActions.propTypes = {
  content: PropTypes.shape({})
};

export default GriddleActions;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/GriddleActions.js